

// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import { LanguageContext } from "../Components/LanguageContext";
// import Rightcontainer from "../Components/Rightcontainer";
// import { FiArrowDownCircle, FiArrowUpCircle } from "react-icons/fi";
// import { MdDownload, MdUpload } from "react-icons/md";
// const Mywallet = ({ user }) => {
//   const { language } = useContext(LanguageContext);

//   const translations = {
//     hi: {
//       status: "खाता स्थिति",
//       verified: "सत्यापन पूरा हुआ",
//       deposit: "डिपॉजिट चिप्स",
//       winnings: "विनिंग चिप्स",
//       availablePlay: "खेलने के लिए उपलब्ध",
//       withdrawBal: "निकालने योग्य शेष",
//       add: "Add Chips",
//       withdraw: "Withdraw",
//       secure: "आपके ट्रांजैक्शन 100% सुरक्षित और एन्क्रिप्टेड हैं।",
//     },
//     en: {
//       status: "Account Status",
//       verified: "Verification Completed",
//       deposit: "Deposit Chips",
//       winnings: "Winning Chips",
//       availablePlay: "Available for play",
//       withdrawBal: "Withdrawable balance",
//       add: "Add Chips",
//       withdraw: "Withdraw",
//       secure: "Your transactions are 100% secure and encrypted.",
//     },
//   };

//   const t = translations[language] || translations.en;

//   const depositAmount = user ? (user.Wallet_balance - user.withdrawAmount).toFixed(2) : "0.00";
//   const winningAmount = user ? user.withdrawAmount.toFixed(2) : "0.00";

//   return (
//     <div className="malik_wallet_page">

//       {/* Top Wallet Summary */}
//       <div className="malik_wallet_summary">

//         <div className="wallet_balance_header">
//           <h5>Total Wallet Balance</h5>
//           <h1>₹ {Number(depositAmount) + Number(winningAmount)}</h1>
//         </div>

//         <div className="wallet_stats_grid">

//           <div className="wallet_stat_box deposited_box">
//             <div className="wallet_stat_icon">
//               <MdDownload />
//             </div>

//             <span>Deposited</span>

//             <h3>₹ {depositAmount}</h3>
//           </div>

//           <div className="wallet_stat_box withdrawn_box">
//             <div className="wallet_stat_icon">
//               <MdUpload />
//             </div>

//             <span>Withdrawn</span>

//             <h3>₹ {winningAmount}</h3>
//           </div>

//         </div>

//       </div>

//       {/* Action Cards */}

//       <div className="wallet_action_grid">

//         <Link to="/addcase" className="wallet_action_card deposit_action">

//           <div className="deposit_plus_badge">
//             <span>+</span>
//           </div>

//           <div className="action_icon">
//             💰
//           </div>

//           <h2>{t.deposit}</h2>

//           <p>Add money instantly to your wallet.</p>

//         </Link>

//         <Link
//           to="/Withdrawopt"
//           className="wallet_action_card withdraw_action"
//         >

//           <div className="action_icon">
//             🏦
//           </div>

//           <h2>{t.withdraw}</h2>

//           <p>Transfer winnings directly to your bank.</p>

//         </Link>

//       </div>

//     </div>
//   );
// };

// export default Mywallet;
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import {
  FiArrowDown,
  FiArrowUp,
  FiArrowUpRight,
  FiPlus,
  FiTrendingUp,
} from "react-icons/fi";
import { MdAccountBalance, MdSavings } from "react-icons/md";
import "../css/Mywallet.css";

const Mywallet = ({ user }) => {
  const { language } = useContext(LanguageContext);

  const translations = {
    hi: {
      deposit: "डिपॉजिट चिप्स",
      withdraw: "Withdraw",
      total: "Total Wallet Balance",
      deposited: "Deposited",
      withdrawn: "Withdrawn",
      totalAdded: "Total added",
      totalSent: "Total sent",
      depositDesc: "Add money instantly to your wallet.",
      withdrawDesc: "Transfer winnings directly to your bank account.",
      secure: "आपके ट्रांजैक्शन सुरक्षित और एन्क्रिप्टेड हैं।",
    },
    en: {
      deposit: "Deposit Chips",
      withdraw: "Withdraw",
      total: "Total Wallet Balance",
      deposited: "Deposited",
      withdrawn: "Withdrawn",
      totalAdded: "Total added",
      totalSent: "Total sent",
      depositDesc: "Add money instantly to your wallet.",
      withdrawDesc: "Transfer winnings directly to your bank account.",
      secure: "Your transactions are 100% secure and encrypted.",
    },
  };

  const t = translations[language] || translations.en;
  const walletBalance = Number(user?.Wallet_balance || 0);
  const winningAmount = Number(user?.withdrawAmount || 0);
  const depositAmount = Math.max(0, walletBalance - winningAmount);
  const totalBalance = depositAmount + winningAmount;

  const formatAmount = (amount) =>
    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  return (
    <main className="malik_wallet_page">
      <section className="malik_wallet_summary" aria-label="Wallet summary">
        <div className="wallet_summary_top">
          <div className="wallet_balance_header">
            <span className="wallet_eyebrow">{t.total}</span>
            <h1>₹ {formatAmount(totalBalance)}</h1>
            <p>Your earnings &amp; balance</p>
            <div className="wallet_header_rule" />
          </div>

          <div className="wallet_hero_art" aria-hidden="true">
            <div className="wallet_art_halo" />
            <img
              src="/images/wallet-card-icon.png"
              alt=""
              className="wallet_hero_image"
              loading="lazy"
            />
          </div>
        </div>

        <div className="wallet_stats_grid">
          <div className="wallet_stat_box deposited_box">
            <div className="wallet_stat_icon">
              <FiArrowDown />
            </div>
            <div className="wallet_stat_content">
              <span>{t.deposited}</span>
              <h3>₹ {formatAmount(depositAmount)}</h3>
              <p>{t.totalAdded}</p>
            </div>
            <FiTrendingUp className="wallet_stat_trend" aria-hidden="true" />
          </div>

          <div className="wallet_stat_box withdrawn_box">
            <div className="wallet_stat_icon">
              <FiArrowUp />
            </div>
            <div className="wallet_stat_content">
              <span>{t.withdrawn}</span>
              <h3>₹ {formatAmount(winningAmount)}</h3>
              <p>{t.totalSent}</p>
            </div>
            <FiTrendingUp className="wallet_stat_trend" aria-hidden="true" />
          </div>
        </div>
      </section>

      <section className="wallet_action_grid" aria-label="Wallet actions">
        <Link to="/addcase" className="wallet_action_card deposit_action">
          <div className="wallet_action_top">
            <div className="action_icon action_icon_deposit">
              <img
                src="https://img.icons8.com/3d-fluency/160/money-bag.png"
                alt=""
                loading="lazy"
              />
            </div>
            <span className="wallet_action_arrow" aria-hidden="true">
              <FiPlus />
            </span>
          </div>

          <div className="wallet_action_copy">
            <h2>{t.deposit}</h2>
            <p>{t.depositDesc}</p>
          </div>

          <img
            className="wallet_action_art deposit_art"
            src="/images/deposit-icon.png"
            alt=""
            loading="lazy"
          />
          {/* <span className="wallet_dots wallet_dots_deposit" aria-hidden="true" /> */}
        </Link>

        <Link to="/Withdrawopt" className="wallet_action_card withdraw_action">
          <div className="wallet_action_top">
            <div className="action_icon action_icon_withdraw">
              <MdAccountBalance />
            </div>
            <span className="wallet_action_arrow" aria-hidden="true">
              <FiArrowUpRight />
            </span>
          </div>

          <div className="wallet_action_copy">
            <h2>{t.withdraw}</h2>
            <p>{t.withdrawDesc}</p>
          </div>

          <img
            className="wallet_action_art withdraw_art"
            src="/images/withdrawal-icon.png"
            alt=""
            loading="lazy"
          />
          {/* <span className="wallet_dots wallet_dots_withdraw" aria-hidden="true" /> */}
        </Link>
      </section>

      <div className="wallet_secure_note">
        <span className="wallet_secure_icon">
          <MdSavings />
        </span>
        <span>{t.secure}</span>
      </div>
    </main>
  );
};

export default Mywallet;
